function getRedeemStatus(status) {
  if (!status) return '-'

  if (status === 1) return 'Pendente'
  
  if (status === 2) return 'Aprovado'

  if (status === 3) return 'Rejeitado'

  return 'Unknown'
}

function getRedeemStatusColor(status) { 
  if (status == 1) return 'orange'

  if (status == 2) return 'green'

  if (status == 3) return 'red'

  return 'grey'
}

function getRedeemStatusIcon(status) {
  if (!status) return 'fas fa-question-circle'

  if (status === 1) return 'fas fa-times'

  if (status === 2) return 'fas fa-check'

  if (status === 3) return 'fas fa-ban'

  return 'fas fa-question-circle'
}

export { getRedeemStatus, getRedeemStatusColor, getRedeemStatusIcon }